import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { logoutAdmin } from '../../services/adminService';

function AdminLayout() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logoutAdmin();
    } finally {
      navigate('/admin/login', { replace: true });
    }
  };

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <NavLink className="brand" to="/admin/dashboard">
          <span className="brand-mark">FS</span>
          <span>FactorStreet Admin</span>
        </NavLink>
        <nav className="admin-nav" aria-label="Admin navigation">
          <NavLink className={({ isActive }) => `admin-nav__link ${isActive ? 'is-active' : ''}`} to="/admin/dashboard">
            Dashboard
          </NavLink>
          <NavLink className={({ isActive }) => `admin-nav__link ${isActive ? 'is-active' : ''}`} to="/admin/contact">
            Contact
          </NavLink>
          <NavLink className={({ isActive }) => `admin-nav__link ${isActive ? 'is-active' : ''}`} to="/admin/jobs">
            Jobs
          </NavLink>
          <NavLink className={({ isActive }) => `admin-nav__link ${isActive ? 'is-active' : ''}`} to="/admin/apply-cms">
            Apply CMS
          </NavLink>
          <NavLink className={({ isActive }) => `admin-nav__link ${isActive ? 'is-active' : ''}`} to="/admin/applications">
            Applications
          </NavLink>
          <NavLink className={({ isActive }) => `admin-nav__link ${isActive ? 'is-active' : ''}`} to="/admin/apply-task">
            Apply Task
          </NavLink>
          <NavLink className={({ isActive }) => `admin-nav__link ${isActive ? 'is-active' : ''}`} to="/admin/task-applicants">
            Task Applicants
          </NavLink>
          <NavLink className={({ isActive }) => `admin-nav__link ${isActive ? 'is-active' : ''}`} to="/admin/emails">
            Emails
          </NavLink>
          <NavLink className={({ isActive }) => `admin-nav__link ${isActive ? 'is-active' : ''}`} to="/admin/backups">
            Backups
          </NavLink>
          <NavLink className={({ isActive }) => `admin-nav__link ${isActive ? 'is-active' : ''}`} to="/admin/seo">
            SEO
          </NavLink>
          <button className="admin-nav__link" onClick={handleLogout} type="button">
            Logout
          </button>
        </nav>
      </aside>
      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
